import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  TextField as MUITextField,
  TextFieldProps as MUITextFieldProps,
} from '@mui/material';
import classNames from 'classnames';
import React, { forwardRef } from 'react';

import classes from './Input.module.scss';

const Input = forwardRef<HTMLDivElement, MUITextFieldProps>(
  ({ disabled, error, children, ...props }, ref) => {
    return (
      <MUITextField
        {...props}
        value={props?.value ?? ''}
        disabled={disabled}
        error={error}
        className={classNames(classes.Root, props.className, {
          [classes.Disabled]: disabled,
          [classes.Error]: error,
        })}
        InputProps={{
          ...props.InputProps,
          classes: {
            ...props.InputProps?.classes,
            sizeSmall: classes.InputSmall,
          },
        }}
        ref={ref}
        InputLabelProps={{
          ...props.InputLabelProps,
          shrink: true,
          classes: {
            ...props.InputLabelProps?.classes,
            focused: classes.InputFocused,
          },
        }}
        FormHelperTextProps={{
          ...props.FormHelperTextProps,
          classes: {
            ...props.FormHelperTextProps?.classes,
            focused: classes.HelperFocused,
          },
        }}
        SelectProps={{
          ...props.SelectProps,
          native: true,
          IconComponent: (props) => (
            <FontAwesomeIcon icon={faChevronDown} {...props} />
          ),
          classes: { ...props.SelectProps?.classes, icon: classes.SelectIcon },
        }}
      >
        {children}
      </MUITextField>
    );
  }
);
Input.displayName = 'Input';

export default Input;
